<template>
  <Modal
    title="Verify your email"
    btnTextSubmit="Submit"
    btnType="submit"
    btnText="Add Group"
    :btnShow="false"
    :isOpenEx="openModal"
    :footerShow="false"
  >
    <template v-slot:body>
      <div v-if="isLoading">
        <Vue3Lottie :animationData="loading" :height="200" :width="200" />
      </div>
      <div v-else>
        <div v-if="isSucces">
        <Vue3Lottie :animationData="succes" :height="200"  />
      </div>
        <div v-else class="space-y-5 pb-5">
            <div class="flex justify-center">
                <div class="bg-white dark:bg-gray-800 rounded-xl border dark:border-gray-700 shadow dark:shadow-inner p-4 sm:p-8 mx-4 max-w-sm">
                    <svg class="w-6 h-6 mb-4 text-gray-800 dark:text-gray-200" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path
                            class="dark:fill-gray-200"
                            d="M1.94631 9.31555C1.42377 9.14137 1.41965 8.86034 1.95706 8.6812L21.0433 2.31913C21.5717 2.14297 21.8748 2.43878 21.7268 2.95706L16.2736 22.0433C16.1226 22.5718 15.8179 22.5901 15.5946 22.0877L12.0002 14.0002L18.0002 6.00017L10.0002 12.0002L1.94631 9.31555Z">
                        </path>
                    </svg>
                    <h1 class="font-bold text-2xl text-gray-800 dark:text-gray-100 mb-1">Check your email</h1>
                    <p class="text-sm font-medium text-gray-600 dark:text-gray-400">We've sent a code to {{ emailProp }}</p>
                    <div class="mt-6">
                        <form>
                            <div v-if="isLoading2">
                              <Vue3Lottie :animationData="loading1" :height="112"  />
                            </div>
                            <div v-else>
                              <div class="flex items-center justify-center">
                                <input
                                  v-model="code"
                                  type="text"
                                  placeholder="- - - -"
                                  maxlength="4"
                                  class="w-full h-16 border dark:bg-gray-500 rounded-lg p-4 text-center mx-auto hover:border-blue-200 focus:outline-none focus:ring focus:ring-blue-400 placeholder:font-medium font-bold text-xl text-blue-900 dark:text-gray-100"
                                />
                              </div>
                              <p class="text-center m-5 text-red-600 text-lg">{{ textError }}</p>
                            </div>
                            <div
                                class="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-2 justify-between mx-auto w-full mt-6 mb-4">
                                <button type="reset" v-on:click="openModal=false"
                                    class="w-full py-2.5 px-4 font-semibold border border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300 text-sm rounded-lg hover:text-gray-900 dark:hover:text-white hover:border-gray-400 dark:hover:border-gray-500">
                                    Cancel
                                </button>
                                <button type="submit" v-on:click.prevent="verifyCodeHandler"
                                    class="w-full py-2.5 bg-blue-600 dark:bg-blue-500 px-4 font-semibold text-gray-50 dark:text-gray-100 text-sm rounded-lg hover:bg-blue-800 dark:hover:bg-blue-700 hover:text-white">
                                    Verify
                                </button>
                            </div>
                        </form>
                    </div>
                    <small class="text-center block text-xs text-gray-600 dark:text-gray-400 font-medium"
                    >
                      Didn't get a code? 
                      <a href="" v-on:click.prevent="sendCodeHandler" class="underline font-semibold text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-500">Click to resend</a></small>
                </div>
            </div>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script>
  import { useCounterStore } from "@/store/counter";
  import { mapActions, mapState } from "pinia";
  import { Icon } from "@iconify/vue";
  import Modal from "@/components/modal.vue";
  import { Vue3Lottie } from 'vue3-lottie';
  import loading from "@/assets/loading10.json"
  import loading1 from "@/assets/loading9.json"
  import succes from "@/assets/succes1.json"

  export default {
    name: "ModalSendMail",
    props:{
      emailProp: {
        type: String,
        required: true,
      },
      openModalEx: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        openModal: false,
        loading, loading1, succes,
        isLoading: true,
        msgRes: '',
        code: '',
        textError: '',
        isLoading2: false,
        isSucces: false
      };
    },
    components: {
      Icon, Modal
      , Vue3Lottie
    },
    methods: {
      ...mapActions(useCounterStore,['sendCode','verifyCode']),
      async verifyCodeHandler(){
        this.isLoading2 = true
        this.textError = ''
        const check = await this.verifyCode(this.code)
        if(check !== true){
          this.textError = check
          this.isLoading2= false
        } else {
          this.isLoading2= false
          this.isSucces = true
          setInterval(() => {
            this.openModal = false
          }, 3000);
        }
      },
      async sendCodeHandler(){
        this.code = ''
        this.openModal = true
        this.isLoading = true
        const check = await this.sendCode()
        if(check !== true){
          this.msgRes = check
        }
        this.isLoading = false
      }
    },
    created(){
    },
    computed: {
    },
    watch:{
      openModalEx(){
        this.openModal = this.openModalEx
      },
      openModal(newVal){
        if(!newVal){
          this.$emit('updateOpen', this.openModal)
        }
      }
    }
  };
</script>